import React, { useState } from "react"

//Components
import { Input, Select, Button, DatePicker, InputNumber } from "components/anti"

//Utils
import { F_M_CONFIRM_PAYMENT } from "lib/function"
import { useDispatch } from "react-redux"
import { SET_SHOW_TOAST, SET_TEXT_TOAST, SET_TYPE_TOAST } from "lib/redux/types"
import { useScrollAnim } from "@components/hooks/hooks"
import { useRouter } from "next/router"

const ConfirmPayment = ({ locale }) => {
  const [trigger, anim] = useScrollAnim()
  const router = useRouter()
  const dispatch = useDispatch()
  const [error, setError] = useState({})
  const initialOptions = [
    {
      label: "BCA - 287 3708000 A/N TRINAGA SELARAS ABADI, PT.",
      value: "BCA - 287 3708000 A/N TRINAGA SELARAS ABADI, PT.",
    },
    // {
    //   label: "MANDIRI - 165.00.2016999.2 A/N TRINAGA SELARAS ABADI, PT.",
    //   value: "MANDIRI - 165.00.2016999.2 A/N TRINAGA SELARAS ABADI, PT.",
    // },
  ]
  //States ************************************************************************* //
  const [state, setState] = React.useState({
    paidValue: initialOptions[0],
    isBtnDisable: false,
    isSuccess: false,
    isBtnLoading: false,
  })
  const [formState, setFormState] = React.useState({
    order_no: "",
    account_name: "",
    payment_bank: "",
    payment_value: null,
    payment_date: null,
  })
  //States ************************************************************************* //

  //Functions ********************************************************************** //
  const handleConfirmPayment = async (e) => {
    let err = false
    e.preventDefault()
    if (!formState.order_no) {
      setError((prev) => ({ ...prev, order_no: true }))
      err = true
    }
    if (!formState.account_name) {
      setError((prev) => ({ ...prev, account_name: true }))
      err = true
    }
    if (!formState.payment_value) {
      setError((prev) => ({ ...prev, payment_value: true }))
      err = true
    }
    if (!formState.payment_date) {
      setError((prev) => ({ ...prev, payment_date: true }))
      err = true
    }

    if (err) {
      return
    }
    let sendData = {
      ...formState,
      order_no: formState.order_no.replace("#", ""),
    }
    setState((prev) => ({ ...prev, isBtnLoading: true }))
    let { data, errors } = await F_M_CONFIRM_PAYMENT({
      ...sendData,
      payment_bank: state.paidValue?.value,
      payment_value: Number(formState?.payment_value),
    })

    if (data) {
      if (data.confirmPayment.status === "success") {
        setState((prev) => ({ ...prev, isBtnLoading: false, isSuccess: true }))
        handleToast("success", data.confirmPayment.message)
        setFormState((prev) => ({
          ...prev,
          order_no: "",
          account_name: "",
          payment_bank: "",
          payment_value: null,
          payment_date: null,
        }))
      } else {
        setState((prev) => ({ ...prev, isBtnLoading: false }))
        handleToast("error", data.confirmPayment.message)
      }
    } else {
      // console.log(errors)
      setState((prev) => ({ ...prev, isBtnLoading: false }))
      handleToast(
        "error",
        errors?.confirmPayment?.message ??
          errors?.[0]?.message ??
          "Oops, something error"
      )
    }
  }
  //Functions ********************************************************************** //
  const handleToast = (type, message) => {
    dispatch({ type: SET_SHOW_TOAST, payload: true })
    dispatch({ type: SET_TYPE_TOAST, payload: type })
    dispatch({
      type: SET_TEXT_TOAST,
      payload: message,
    })
    setTimeout(() => {
      dispatch({ type: SET_SHOW_TOAST, payload: false })
    }, 3000)
  }

  //React Operation **************************************************************** //
  React.useEffect(() => {
    let { order_no, account_name, payment_bank, payment_value, payment_date } =
      formState

    // if (order_no && account_name && payment_bank && payment_value && payment_date) {
    //    setState(prev => ({ ...prev, isBtnDisable: false }))
    // }
  }, [formState])
  //React Operation **************************************************************** //

  return (
    <section className="sc-confirm-payment" ref={trigger}>
      <div className="container mw-md">
        <div className="btn-back-wrapper">
          <span
            className="ail ai-arrow-left font-weight-bold"
            style={{ cursor: "pointer" }}
            onClick={() => router.back()}
          />
        </div>
        <h3 className="title-page">
          {locale === "id" ? "Konfirmasi Pembayaran" : "Confirm Payment"}
        </h3>
        <h6 className="subtitle-page">
          {locale === "id"
            ? "Hanya untuk bank transfer"
            : "For bank transfer only."}
        </h6>
        <form className="form-confirm-wrapper">
          <div className={`form-row row-4`}>
            <div className="form-group col-12">
              <Input
                label="Order #"
                placeholder={
                  locale === "id"
                    ? "Masukkan no order anda"
                    : "Insert your order number"
                }
                name="order_no"
                onChange={(e) => {
                  if (!e.target.value) {
                    setError((prev) => ({ ...prev, [e.target.name]: true }))
                  } else {
                    setError((prev) => ({ ...prev, [e.target.name]: false }))
                  }
                  setFormState((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }}
                value={formState?.order_no}
              />
              {error.order_no && (
                <div className="invalid-feedback">{"Insert Order id"}</div>
              )}
            </div>
            <div className="form-group col-12">
              <InputNumber
                label={
                  locale === "id"
                    ? "Jumlah yang Dibayarkan (Masukkan nomor saja, tanpa Rp/IDR/dot/koma)"
                    : "Amount Paid  (Insert number only, without Rp/IDR/dot/comma)"
                }
                placeholder={
                  locale === "id" ? "Masukkan jumlah" : "Insert amount"
                }
                name="payment_value"
                onChange={(e) => {
                  if (!e.target.value) {
                    setError((prev) => ({ ...prev, [e.target.name]: true }))
                  } else {
                    setError((prev) => ({ ...prev, [e.target.name]: false }))
                  }
                  setFormState((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }}
                value={formState?.payment_value}
              />
              {error.payment_value && (
                <div className="invalid-feedback">{"Insert Amount"}</div>
              )}
            </div>
            <div className="form-group col-12">
              <Input
                label={locale === "id" ? "Nama Akun Bank" : "Bank Account Name"}
                placeholder={
                  locale === "id"
                    ? "Masukkan nama rekening bank Anda"
                    : "Insert your bank account name"
                }
                name="account_name"
                onChange={(e) => {
                  if (!e.target.value) {
                    setError((prev) => ({ ...prev, [e.target.name]: true }))
                  } else {
                    setError((prev) => ({ ...prev, [e.target.name]: false }))
                  }
                  setFormState((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }}
                value={formState?.account_name}
              />
              {error.account_name && (
                <div className="invalid-feedback">
                  {"Insert Bank Account Name"}
                </div>
              )}
            </div>
            <div className="form-group col-12">
              <DatePicker
                name="date"
                wrapperClassName="w-100"
                placeholder="DD/MM/YYYY"
                onChange={(e) => {
                  if (!e) {
                    setError((prev) => ({ ...prev, payment_date: true }))
                  } else {
                    setError((prev) => ({ ...prev, payment_date: false }))
                  }
                  setFormState((prev) => ({ ...prev, payment_date: e }))
                }}
                selected={formState?.payment_date}
                label={locale === "id" ? "Tanggal Pembayaran" : "Payment Date"}
              />
              {error.payment_date && (
                <div className="invalid-feedback">{"Insert Payment Date"}</div>
              )}
            </div>
            <div className="form-group col-12">
              <Select
                label={locale === "id" ? "Dibayarkan Kepada" : "Paid To"}
                options={initialOptions}
                onChange={(_, v) =>
                  setState((prev) => ({ ...prev, paidValue: v }))
                }
                value={state.paidValue}
              />
            </div>
          </div>
          <div className={`w-100 text-right mt-2 ${anim(1)}`}>
            <Button
              className="mr-4 w-25 d-none d-sm-inline-block"
              variant="white"
              link="/"
            >
              {locale === "id" ? "Batal" : "Cancel"}
            </Button>
            <Button
              // disabled={state.isBtnDisable}
              className={`w-100 w-md-25 ${state.isBtnLoading && "loading"}`}
              loader
              onClick={(e) => handleConfirmPayment(e)}
            >
              {state.isSuccess ? (
                <i className="air ai-check"></i>
              ) : locale === "id" ? (
                "Kirim"
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        </form>
      </div>
    </section>
  )
}

export default ConfirmPayment
